import script from "./Email.vue?vue&type=script&setup=true&lang=ts"
export * from "./Email.vue?vue&type=script&setup=true&lang=ts"

export default script